import type { AppSvgIconType } from '@libs/ui';
import {
  CategoryType,
  isAirportSuggestion,
  isFerryRouteSuggestion,
} from '@libs/trip-planner-interfaces';
import type {
  AutoCompleteSuggestion,
  FerryAutoCompleteSuggestion,
  FlightAutoCompleteSuggestion,
} from '@libs/trip-planner-interfaces';

export function getIconNameFromAutoCompleteSuggestionCategory(
  category: CategoryType
): AppSvgIconType {
  switch (category) {
    case CategoryType.Hotel:
      return 'bed';

    case CategoryType.Airport:
      return 'airplane';

    default:
      return 'locationMark';
  }
}

export function handleSelectedSuggestion(
  suggestion: AutoCompleteSuggestion,
  callbacks: {
    onAirportSelected: (suggestion: FlightAutoCompleteSuggestion) => void;
    onFerryRouteSelected: (suggestion: FerryAutoCompleteSuggestion) => void;
    onGenericSuggestionSelected: (suggestion: AutoCompleteSuggestion) => void;
  }
): void {
  if (isAirportSuggestion(suggestion)) {
    callbacks.onAirportSelected(suggestion);
  } else if (isFerryRouteSuggestion(suggestion)) {
    callbacks.onFerryRouteSelected(suggestion);
  } else {
    callbacks.onGenericSuggestionSelected(suggestion);
  }
}

export function mapSuggestionsToDropdownItems(
  suggestions: AutoCompleteSuggestion[] | undefined
): { label: string; index: number }[] {
  return (
    suggestions?.map((suggestion, index) => ({
      label: suggestion.label,
      index,
    })) ?? []
  );
}
